import React, { Component } from 'react';
import { connect } from '@common/components/base.component';
import imprimirSolicitacaoSelector from '../store/imprimirSolicitacao.selectors';
import imprimirSolicitacaoActions from '../store/imprimirSolicitacao.actions';
import autoBind from 'react-autobind';
import StaticGrid from '@common/components/grid/staticGrid.component';
import Button from '@material-ui/core/Button';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const options = {
      filterVersion: Math.random(),
      noStorage: true,
      webStorage: 'RedeSIM.ImprimirSolicitacao.Solicitante',
      applySearchOnLoad: true,
      isNotCheckable: true,
    };

    const columns = [
      {
        fieldName: 'Protocolo',
        dataName: 'NumeroProtocolo',
        show: true,
        type: 'text',
        removeFilter: true,
      },
      {
        fieldName: 'Cnpj',
        dataName: 'CnpjEmpresa',
        show: true,
        type: 'text',
        removeFilter: true,
      },
      {
        fieldName: 'Nome Empresa',
        dataName: 'NomeEmpresa',
        show: true,
        type: 'text',
        removeFilter: true,
      },
      {
        fieldName: 'Ccm',
        dataName: 'Ccm',
        show: true,
        type: 'number',
        removeFilter: true,
      },
    ];

    const actions = [
      {
        title: 'Imprimir Solicitação',
        icon: 'fas fa-print',
        onClick: async (dataItem) => {
          this.props.imprimirSolicitacaoActions.abrirImprimirSolicitacao(dataItem);
        },
      },
    ];

    const order = [{ fieldName: 'Protocolo', dataName: 'Protocolo', order: 'A' }];

    const toolbar = {
      title: '',
      prefix: ' ',
      tools: {
        limpar: false,
      },
    };

    this.config = {
      order,
      columns,
      actions,
      options,
      toolbar,
    };
  }

  onClose() {
    this.props.imprimirSolicitacaoActions.setImprimirSolicitacaoGridPesquisa([]);
  }

  render() {
    const { imprimirSolicitacao } = this.props.imprimirSolicitacaoSelector;
    const { GridImprimirSolicitacaoPesquisa } = imprimirSolicitacao;

    return (
      <>
        <StaticGrid {...this.config} itens={GridImprimirSolicitacaoPesquisa.asMutable()}></StaticGrid>
        <div style={{ textAlign: 'right' }}>
          <Button variant="outlined" color="primary" onClick={this.onClose}>
            <i className={'mr-1 fa fa-angle-double-left'} /> {'Voltar'}
          </Button>
        </div>
      </>
    );
  }
}

export default connect({
  actions: {
    imprimirSolicitacaoActions,
  },
  selectors: {
    imprimirSolicitacaoSelector,
  },
})(Container);
